import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import "./Toasters.scss";
import { DEFAULT_TOAST_TIMEOUT } from "../../../utils/constants";
import { removeToast } from "../../../store/toasts";

const Toasters = ({ toastsList }) => {
	const { formatMessage } = useIntl();

	const hideToast = (id) => {
		setTimeout(() => {
			if (document.getElementById(id)) {
				document.getElementById(id).parentElement.removeChild(document.getElementById(id));
			}
			removeToast(id);
		}, DEFAULT_TOAST_TIMEOUT);
	};

	return (
		<div className="custom-toast flex direction-col align-items-start">
			{toastsList &&
				toastsList.map((toast) => (
					<div key={toast.id} id={toast.id} className={`toast-item ${toast.type ? toast.type : ""}`}>
						<div className="text text-body--3">{formatMessage({ id: toast.message })}</div>
						{hideToast(toast.id)}
					</div>
				))}
		</div>
	);
};

export default connect((state) => ({ ...state.toasts }), {})(Toasters);
